import { searchContent, getQueryStringResults } from '@plone/volto/actions';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import { consultaManual, extrairConfigs } from './compor';
import { caminhosNoHero } from './destaquesDaPagina';
import { inteiro, loteDaConsulta } from './paginacao';

// Renderização no servidor para o NewsGrid: dispara, ainda no servidor, a
// mesma busca que o View dispara no navegador — sob a MESMA chave de
// subrequest. Com isso o HTML já sai com as matérias e o cliente apenas
// rehidrata. Sem isto, a listagem chega vazia a buscadores e a qualquer
// leitor de HTML que não execute JavaScript.
//
// A chave precisa casar com a do View (`agsusNewsGrid_${block}`): aqui o id
// do bloco chega como `id`.
export default function getNewsGridAsyncData({
  dispatch,
  path,
  id,
  data,
  content,
}) {
  const key = `agsusNewsGrid_${id}`;
  const mode = data.mode || 'auto';

  if (mode === 'query') {
    if (!data.query || (data.query.query || []).length === 0) {
      return [async () => null];
    }
    return [
      dispatch(
        getQueryStringResults(
          path,
          {
            ...data.query,
            b_size: loteDaConsulta(data.query.b_size),
            fullobjects: true,
          },
          key,
          1,
        ),
      ),
    ];
  }

  if (mode === 'manual') {
    // Mesma busca e mesma chave do View: o HTML do servidor só traz o que a
    // busca devolve (nada de cópia gravada no bloco; desde 22/10/2026, como na
    // intranet). Só a consulta principal (por UID; ver consultaManual): por
    // caminho, sem VHM, o SSR não acharia nada. A complementar fica com o
    // navegador.
    const consulta = consultaManual(
      extrairConfigs(data.items, flattenToAppURL),
    );
    if (!consulta) return [async () => null];
    return [dispatch(searchContent('', consulta.principal, key))];
  }

  // modo 'auto' — espelha o efeito do View. b_size pede um item a mais
  // porque, nas páginas de notícia, o View exclui a própria matéria da
  // lista; o excedente é cortado pelo slice(limit) de todo modo.
  const portalTypes =
    data.portalTypes && data.portalTypes.length > 0
      ? data.portalTypes
      : ['News Item'];
  return [
    dispatch(
      searchContent(
        data.parentPath || '/noticias',
        {
          portal_type: portalTypes,
          sort_on: data.sortOn || 'effective',
          sort_order: 'descending',
          // e mais uma por notícia que o Hero da página já mostra (o View a
          // deixa de fora; ver destaquesDaPagina.js)
          b_size:
            inteiro(data.limit, 6) +
            1 +
            caminhosNoHero(content?.blocks, flattenToAppURL).length,
          fullobjects: true,
        },
        key,
      ),
    ),
  ];
}
